<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <div class="card">
            <!--desktop-->
            <div class="card-body p-0" *ngIf="_utilsService.isDesktop">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [scrollbarH]="true" [rowHeight]="50" [footerHeight]="60" [rows]="list_contracts_manager">
                    <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" [sortable]="false" [width]="800">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span class="font-medium-1">{{ row.title }}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" [width]="100">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div>
                                <button class="bg-transparent border-0 text-secondary pr-1" routerLink="/dashboard/manager-contract/edit/{{row.type}}">
                                    <i [data-feather]="'edit-2'" size="19"></i>
                                </button>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

            <!--mobile - tablet-->
            <div class="card-body p-0" *ngIf="_utilsService.isMobile || _utilsService.isTablet">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [scrollbarH]="true" [scrollbarV]="false" [rowHeight]="50" [footerHeight]="50" [rows]="list_contracts_manager">
                    <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" [sortable]="false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="row list-item-mobile">
                                <div class="col-10 pl-0">
                                    <span class="font-medium-1">{{ row.title }}</span>
                                </div>

                                <div class="col-2">
                                    <button class="bg-transparent border-0 text-secondary" routerLink="/dashboard/manager-contract/edit/{{row.type}}">
                                        <i [data-feather]="'edit-2'" size="19"></i>
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </div>
    </div>
</div>